import store from "@/store";
import WebIM from "@/utils/WebIM";
import { updateLastSesstionTime } from "@/api/request/concatService";
import moment from "moment";
import router from "@/router";
import { singleCase } from "@/utils/tool";

const callbacks = [];
let pending = false;
const onlyMap = new Map();

/**
 * @author lihh
 * @description 异步队列更新
 * @param {*} fn 表示调用函数
 * @param level micro 微任务 macro 宏任务
 * @param time 表示等待时间 只对宏任务有效果
 * @param onlyVal 表示唯一值 用来去重用的
 */
export function asyncQueueFlush(fn, level = "micro", time = 0, onlyVal) {
    /* 判断是否已经在任务中 */
    if ( onlyVal ) {
        if ( onlyMap.has(onlyVal) ) return;
        onlyMap.set(onlyVal, onlyVal);
    }
    // 更新队列
    const updateQueue = () => {
        callbacks.forEach(fn => fn());
        callbacks.length = 0;
        onlyMap.clear();
        pending = false;
    };

    // 添加队列
    callbacks.push(fn);
    if ( !pending ) {
        // 是否支持promise 反之使用宏任务 我们优先考虑微任务
        if ( typeof Promise !== "undefined" && level === "micro" ) {
            Promise.resolve().then(() => updateQueue());
        } else {
            setTimeout(updateQueue, time);
        }
    }
}

/**
 * @description 创建用户
 * @param obj 用户id 以及昵称
 */

export function _createUserJson(obj) {
    return {
        ...obj,
        subscription: "both",
        jid: {
            appKey: WebIM.config.appkey,
            clientResource: "webim_1598519637501",
            domain: WebIM.config.Host,
            name: obj.userName,
            nick: obj.nickName,
        },
    };
}

/**
 * @description 创建群聊
 * @param obj 群聊id 以及名称等
 */
export function _createGroupJson(options = {}) {
    // 解构数据
    let {
        groupHeadicon,
        groupName,
        hxGroupId: groupId,
        isDisturb = 2,
        isTop = 2,
        isOwner = 1,
        type,
        // 我在本群的昵称
        nickName,
        companyId,
        // 表示未读个数
        unreadNum,
        // 公司名称
        companyName,
        // 公司介绍
        companyProfile,
    } = options;

    // 判断昵称是否有值  如果没有值的话 获取缓存中的值
    if ( !nickName ) {
        // 登录用户信息
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        nickName = userInfo["nickName"];
    }

    if ( singleCase.__initQueryGroupState__ === 1 ) singleCase.__initQueryGroupValue__[groupId] = unreadNum;
    return {
        groupHeadicon,
        groupName,
        groupId,
        isDisturb,
        isTop,
        type,
        isOwner,
        nickName,
        companyId,
        unreadNum: singleCase.__initQueryGroupState__ === 1 ? (unreadNum || 0) : (singleCase.__initQueryGroupValue__[groupId] || 0),
        companyName,
        companyProfile,
    };
}

/**
 * @description 修改单聊或群聊的顺序
 */

export function stuSortUserOrGroup(type, name, otherOptions) {
    if (!name || name == "") return
    /* contact/chat 表示单聊 group/groupchat 群聊 */
    const targetArr = [ "contact", "chat" ];
    /* 判断name是否是字符串 */
    if ( typeof name !== "string" ) throw new Error("排序的{name}必须是字符串");
    store.dispatch("stuSortList", { isSingle: targetArr.includes(type), name, otherOptions });

    if ( targetArr.includes(type) ) {
        updateLastConcatTime(name);
    }
}

/**
 * @author lihh
 * @description 更新最后沟通时间
 * @param id 表示沟通用户 如果没有用本地id
 */
function updateLastConcatTime(id) {

    if ( !id ) id = localStorage.getItem("currentId");
    /* 更新数据回调 */
    const updateDataFun = () => updateLastSesstionTime({ userId: id });

    /* 当天时间，缓存key，缓存 */
    const currentNow = moment().format("YYYYMMDD");
    let updateTimeCache = localStorage.getItem("91SingleChat_stu");

    let options = { [id]: currentNow };
    /* 根据当天日期是否有缓存 ? 没有进行更新 : 忽略 */
    if ( updateTimeCache ) {
        updateTimeCache = JSON.parse(updateTimeCache);
        if ( updateTimeCache[id] === currentNow ) return;

        /* 更新缓存数据 */
        options = { ...updateTimeCache, ...options };
    }

    /* 更新缓存 */
    localStorage.setItem("91SingleChat_stu", JSON.stringify(options));
    updateDataFun();
}

/**
 * @author lihh
 * @description 更新群消息共同处理-就是为了排列顺序
 * @param state 元数据
 * @param {*} afterData 需要处理的数据
 */
export function commonUpdateGroupList(state, afterData) {
    // 解构是否置顶
    const { isTop } = afterData;
    // 判断是否置顶 如果是特殊情况置顶了  就处理特殊情况
    if ( isTop == 1 ) {
        // 插入到所有人的前面
        state.userListStu.groupUserList.unshift(afterData);
    } else {
        // 获取不置顶的下标
        const noTopIndex = state.userListStu.groupUserList.findIndex(item => + item.isTop !== 1);

        // 判断剩余的数据是否都是置顶 如果是-1表示都是置顶 直接添加到最后 反之 按下标插入
        if ( noTopIndex != - 1 ) {
            state.userListStu.groupUserList.splice(noTopIndex, 0, afterData);
        } else {
            state.userListStu.groupUserList.push(afterData);
        }
    }
}

/**
 * @author lihh
 * @description 跳转页面添加好友
 * @param arguments userName, pageName, jobId
 */
export async function skipPageAddSingleUser() {
    /* 解构参数 */
    const params = [].slice.call(arguments);
    let [ userName, pageName, jobId, options = {}, callback = {} ] = params;
    /* 判断传递值是否正确 */
    if ( !/^\w+$/gi.test(userName) ) throw new Error("用户token格式不对");
    /* eslint-disable */
    const nameFlag = ROUTES.some(item => item.name === pageName);
    if ( !nameFlag ) throw new Error("跳转路由不存在");

    /* 跳转页面 */
    store.dispatch("skipPageAddSingleUserStu", { userName, jobId }).then(() => {
        localStorage.setItem("currentId", userName);
        uni.$Router.push(options ? { name: pageName, params: options } : { name: pageName });
        callback && callback();
    });
}


/**
 * @description 添加好友发送消息但不跳转页面
 * @param arguments userName, jobId
 */
 export async function AddSingleUserToChat() {
  /* 解构参数 */
  const params = [].slice.call(arguments);
  console.log(params)
  let [userName, jobId, positionName,isFrist,callback={}] = params;
  
  /* 判断传递值是否正确 */
  if (!/^\w+$/gi.test(userName)) throw new Error("用户token格式不对");
  /* eslint-disable */
  /* 跳转页面 */
  store.dispatch("AddSingleUserToChat", {userName, jobId,positionName,isFrist}).then(() => {
      callback && callback()
  });
}

/**
 * @author lihh
 * @description 跳转页面进入群聊
 * @param arguments groupName, pageName
 */
export async function skipPageAddGroup() {
    /* 解构参数 */
    const params = [].slice.call(arguments);
    let [ groupId, pageName ] = params;
    /* 判断传递值是否正确 */
    if ( !/^\w+$/gi.test(groupId) ) throw new Error("用户token格式不对");
    /* eslint-disable */
    /* 跳转页面 */
    store.dispatch("skipPageAddGroup", { groupId }).then(() => {
        localStorage.setItem("currentId", groupId);
        router.push({ name: pageName });
    });
}

/**
 * @author lihh
 * @description 获取群消息是否是免打扰模式
 * @param groupId 表示群id
 * @return true 表示免打扰模式 反之 不是
 */
export function groupMsgDisturb(groupId) {
    const val = queryGroupInfoStatus(groupId, "isDisturb");
    return + val === 1;
}

/**
 * @author lihh
 * @description 查询群消息状态
 * @param groupId 表示群id
 * @param field 表示获取值的字段
 */
function queryGroupInfoStatus(groupId, field) {
    /* 获取群用户 */
    const { groupUserList } = store.state.chat.userListStu;
    const localIndex = groupUserList.findIndex(item => item.groupId === groupId);
    if ( localIndex === - 1 ) return 0;

    /* 判断字符是否存在 */
    if ( !Reflect.has(groupUserList[localIndex], field) ) return 0;
    return groupUserList[localIndex][field];
}



// WEBPACK FOOTER //
// ./src/utils/groupChat.js